export const stateKeys = {
  visible: 'visible',
  editComment: 'editComment',
  text: 'text',
  files: 'files',
  images: 'images',
};
